import React from 'react';

import { HN_SKJEMA_FRONTEND_RESOURCES } from 'src/constants/constants';
import { useResources } from 'src/resources';
import { useAppDispatch, useAppSelector } from 'src/store/reducers';
import { toggleAttachmentErrorModal } from 'src/store/reducers/uiSlice';

import type { HNSkjemaFrontend } from 'src/types/Resources';

import Modal from '@helsenorge/designsystem-react/components/Modal';

export const AttachementErrorModal = (): React.JSX.Element | null => {
  const dispatch = useAppDispatch();
  const showAttachmentErrorModal = useAppSelector(state => state.refero.ui.showAttachmentErrorModal);
  const attachmentErrorText = useAppSelector(state => state.refero.ui.attachmentErrorText);

  const resources = useResources<HNSkjemaFrontend>(HN_SKJEMA_FRONTEND_RESOURCES);

  const confirmationActionButton = resources?.confirmationActionButton;
  return showAttachmentErrorModal ? (
    <Modal
      variant="error"
      testId="attachment-max-files-error"
      title={'Teknisk feil'}
      onClose={(): void => {
        dispatch(toggleAttachmentErrorModal({ show: false, text: [] }));
      }}
      onSuccess={(): void => {
        dispatch(toggleAttachmentErrorModal({ show: false, text: [] }));
      }}
      primaryButtonText={confirmationActionButton}
    >
      {attachmentErrorText.map((error, index) => (
        <p key={index}>{error}</p>
      ))}
    </Modal>
  ) : null;
};
export default AttachementErrorModal;
